import { track } from '@/utils/pendo.js'

class ScrollTracker {
    constructor(target, properties) {
        this.flushed = 0
        this.listener = () => this.onscroll()
        this.percent = 0
        this._properties = properties
        this.target = target
        this.timeout = null
    }

    bind() {
        this.target.addEventListener('scroll', this.listener, { passive: true })
    }

    unbind() {
        this.target.removeEventListener('scroll', this.listener, { passive: true })
        this.flush()
    }

    flush(clear) {
        if (this.percent > this.flushed) {
            track('scroll', { ...this.properties, percent: this.percent.toString() })
        }

        if (clear) {
            this.percent = 0
            this.flushed = 0
        } else {
            this.flushed = this.percent
        }
    }

    onscroll() {
        if (this.percent >= 100) {
            return
        }

        const currentPercent = (this.target.scrollTop / (this.target.scrollHeight - this.target.clientHeight)) * 100

        if (currentPercent <= this.percent) {
            return
        }

        this.percent = currentPercent

        if (this.timeout !== null) {
            clearTimeout(this.timeout)
        }

        this.timeout = setTimeout(() => this.flush(false), 500)
    }

    get properties() {
        return this._properties
    }

    set properties(properties) {
        this.flush(true)
        this._properties = properties
    }
}

export default {
    name: 'track-scroll',
    wireup: {
        bind: function (target, binding) {
            const instance = new ScrollTracker(target, binding.value)
            target.$trackScroll = instance
            instance.bind()
        },
        update: function (target, binding) {
            const trackScroll = target.$trackScroll
            if (trackScroll) {
                trackScroll.properties = binding.value
            }
        },
        unbind: function (target) {
            const trackScroll = target.$trackScroll

            if (trackScroll) {
                trackScroll.unbind()
                delete target.$trackScroll
            }
        },
    },
}
